module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    directives: [{
      name: "iscroll",
      rawName: "v-iscroll"
    }],
    staticClass: "personnel-inner"
  }, [_c('div', {
    staticClass: "warp-pre"
  }, _vm._l((_vm.listArr), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.link(false)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#/index/people"
      }
    }, [_c('div', {
      staticClass: "pic",
      staticStyle: {
        "background-image": "url('static/images/ex_pic16.jpg')"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(item.number))])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23f9760f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personnel-list.vue
// module id = 176
// module chunks = 1